export const ADD_POC = "ADD_POC";
export const GET_POC_BY_ID = "GET_POC_BY_ID";
export const EDIT_POC = "EDIT_POC";